import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { sessionRecordingControl } from 'features/analytics/sessionRecordingControl'
import { MANAGE_USER_PERMISSIONS_PERMISSIONS_LIST } from 'features/manageUsers'
import { DropdownLink } from 'features/navbar/NavbarDropdown'
import { PermissionsGate } from 'features/permissions'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { createUsersSearch } from 'routes/users/-searchParams'
import styled from 'styled-components'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

import {
  type ConfigSettingsProps,
  type ConfigSettingsState,
} from './useConfigSettingsState'

const DropdownToggleButton = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.25rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  color: ${({ theme }) => theme.forecast.secondaryText};

  &:hover {
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

export function ConfigSettingsTopBarMenuItems({
  orgID,
  siteID,
  state,
}: ConfigSettingsProps & { state: ConfigSettingsState }) {
  return (
    <>
      <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
        <DropdownLink to='/app-config'>Org & Site App Config</DropdownLink>
      </PermissionsGate>

      {orgID && (
        <PermissionsGate requires={MANAGE_USER_PERMISSIONS_PERMISSIONS_LIST}>
          <DropdownLink
            to='/users'
            search={createUsersSearch({ orgId: orgID, siteId: siteID })}>
            Manage Users
          </DropdownLink>
        </PermissionsGate>
      )}

      <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
        <DropdownLink to='/admin/users'>Manage Permissions</DropdownLink>
      </PermissionsGate>

      <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
        <DropdownLink to='/admin/access'>Manage Access</DropdownLink>
      </PermissionsGate>

      {state.isSessionRecordingOrg && (
        <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
          <DropdownMenu.Item
            asChild
            onSelect={(e) => {
              e.preventDefault()
              state.setRecordingOn(sessionRecordingControl.toggle())
            }}>
            <DropdownToggleButton>
              Session recording:{' '}
              {state.recordingOn ? 'On' : 'Off (this browser)'}
            </DropdownToggleButton>
          </DropdownMenu.Item>
        </PermissionsGate>
      )}

      <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
        <DropdownLink to='/health-check'>Health Check</DropdownLink>
      </PermissionsGate>

      {orgID && (
        <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
          <DropdownLink
            to={'/extensions'}
            search={(prev) => ({
              ...prev,
              [SEARCH_PARAM_ORG_ID]: orgID,
              [SEARCH_PARAM_SITE_ID]: siteID,
            })}>
            Manage Extensions
          </DropdownLink>
        </PermissionsGate>
      )}
    </>
  )
}
